import Script from "next/script"
import Link from "next/link"
import SbEditable from "storyblok-react"
import InlineAccordion from "components/DynamicComponent/atoms/InlineAccordion"
import { getPlainText } from "utilities/getPlainText"

export default function FAQSection({ blok }) {
  return (
    <>
      <section className="faq-section px-8">
        <div className="relative mx-auto max-w-screen-xl border-t border-t-blue py-12 faq-grid">
          <h2 className="pb-6 text-m2 leading-9 uppercase">{blok.heading}</h2>
          <nav className="flex flex-col gap-y-4 lg:self-start text-navy lg:border-l lg:border-l-blue pb-4 lg:pb-6 lg:pl-4 lg:sticky top-12">
            <h2 className="font-secondary font-bold text-m1 hover:underline leading-none uppercase w-max pb-2">
              Jump to...
            </h2>
            {blok.categories?.map((category, idx) =>
              blok?.items[category?.value] && blok.items[category.value].length ? (
                <Link
                  href={`#${category?.value.toLowerCase()}`}
                  className="plain-navy-arrow font-primary sm:w-max text-navy uppercase hover:underline relative"
                  scroll={false}
                  key={idx}
                >
                  {category?.name.toLowerCase()}
                </Link>
              ) : null
            )}
          </nav>
          <div className="faq-section-container">
            {blok.categories.map((category, idx) => {
              return blok?.items[category?.value] && blok.items[category.value].length ? (
                <>
                  <h3 id={category.value} className="text-m1 font-bold font-secondary pb-4 pt-8 first:pt-0" key={idx}>
                    {category.name}
                  </h3>
                  {blok.items[category.value].map((item) => (
                    <SbEditable content={item} key={item.title}>
                      <InlineAccordion blok={item} />
                    </SbEditable>
                  ))}
                </>
              ) : null
            })}
          </div>
        </div>
      </section>
      <Script type="application/ld+json" id="frequently-asked-questions-schema">
        {`{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": 
            ${JSON.stringify(
              blok?.categories
                .map(({ value }) => {
                  if (blok?.items[value] && blok.items[value].length) {
                    return blok?.items[value].map((question) => {
                      return {
                        "@type": "Question",
                        name: `${question.title}`,
                        acceptedAnswer: {
                          "@type": "Answer",
                          text: `${getPlainText(question.content, { addNewlines: false })}`,
                        },
                      }
                    })
                  }
                })
                .flat()
            )}
          
        }`}
      </Script>
    </>
  )
}
